// Code generated by OpenAPI Generator (https://openapi-generator.tech), manual changes will be lost - read more on https://github.com/algolia/api-clients-automation. DO NOT EDIT.

import { gzipSync } from 'node:zlib';

export type LiteClient = ReturnType<typeof createLiteClient>;

import { createMemoryCache, createNullCache, createNullLogger } from '@algolia/client-common';
import { createHttpRequester } from '@algolia/requester-node-http';

import type { ClientOptions } from '@algolia/client-common';

import { createLiteClient } from '../src/liteClient';

export { apiClientVersion } from '../src/liteClient';

export * from '../model';

export function liteClient(appId: string, apiKey: string, options?: ClientOptions | undefined): LiteClient {
  if (!appId || typeof appId !== 'string') {
    throw new Error('`appId` is missing.');
  }

  if (!apiKey || typeof apiKey !== 'string') {
    throw new Error('`apiKey` is missing.');
  }

  return createLiteClient({
    appId,
    apiKey,
    timeouts: {
      connect: 2000,
      read: 5000,
      write: 30000,
    },
    logger: createNullLogger(),
    requester: createHttpRequester(),
    algoliaAgents: [{ segment: 'Node.js', version: process.versions.node }],
    responsesCache: createNullCache(),
    requestsCache: createNullCache(),
    hostsCache: createMemoryCache(),
    compress: async (data: string): Promise<Uint8Array> => gzipSync(Buffer.from(data)),
    ...options,
  });
}
